<template>
  <div class="content">
    <div class="detail-drawer">
      <div class="drawer-title" :style="{'line-height': landingPageStyle?'' : '53px'}">
        <div class="drawer-title-icon">
          <i class="el-icon-close" @click="handleCloseDrawer" style="cursor:pointer"></i>
        </div>
        <div class="drawer-title-header">
          <div class="drawer-title-text">
            <div>
              落地页:&nbsp;{{ landingPageForm.landingPageName }} &nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="drawer-operate">
            <el-button type="text" icon="el-icon-download" @click="downloadFile" v-permission="'media:download'"></el-button>
          </div>
        </div>
      </div>
      <el-tabs tab-position="left" v-model="activeName" style="height: 100%;" class="drawer-tabs">
        <el-tab-pane name="detail">
          <span slot="label">
            <i class="el-icon-view"></i> 详情
          </span>
          <div class="title-text">基础设置</div>
          <el-form style="width: 100%;" ref="landingPageForm" :model="landingPageForm" label-width="117px" label-position="left">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-form ref="landingPageForm" :model="landingPageForm" label-width="117px" label-position="left">
                  <div style="width: 80%;margin-left: 20px;">
                    <media-view
                      width="100%"
                      height="100%"
                      :mediaClassId="['ts', 'mp4'].includes(landingPageForm.format) ? 2 : 1"
                      :src="landingPageForm.landingPageIcon"
                      :previewSrc="landingPageForm.mp4Url"
                    ></media-view>
                  </div>
                </el-form>
              </el-col>
              <el-col :span="14">
                <el-form-item label="落地页ID">{{ landingPageForm.landingPageId }}</el-form-item>
                <el-form-item label="广告主">
                  {{ landingPageForm.adDspPartner ? landingPageForm.adDspPartner.partnerName : '' }}
                </el-form-item>
                <el-form-item label="落地页类型">
                  {{ landingPageForm.landingPageClass ? landingPageForm.landingPageClass.landingPageClassName : '' }}
                </el-form-item>
                <el-form-item v-if="landingPageForm.landingPageUrl" label="落地页地址">
                  <div style="word-break:break-all">{{ landingPageForm.landingPageUrl }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="log">
          <span slot="label">
            <i class="el-icon-date"></i> 日志
          </span>
          <ContentBox>
            <Table :props="logTable.props" :header="logTable.header" :data="logTable.data" />
          </ContentBox>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    landingPageForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      landingPageStyle: false,
      activeName: 'detail',
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '操作者',
            align: 'left',
            prop: 'operator',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.userType) {
                return params.userType === 1 ? '管理后台' : params.operator
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作类型',
            align: 'left',
            prop: 'userType',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.operateType || params.operateType === 0) {
                return this.$consts.operateTypeText[params.operateType]
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作内容',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      }
    }
  },
  watch: {
    landingPageForm: {
      handler(newValue) {
        this.logTable.data = newValue.landingPageLogList
      },
      deep: true
    }
  },
  created() {
    this.logTable.data = this.landingPageForm.landingPageLogList
  },
  methods: {
    handleCloseDrawer() {
      this.$emit('closeDrawer', true)
    },
    downloadFile() {
      if (this.landingPageForm.landingPageUrl) {
        window.location.href = this.landingPageForm.landingPageUrl
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
.detail-drawer
  height inherit
  width 100%
.drawer-title
  display flex
  flex-direction row
  align-items center
  height 53px
  /* line-height: 53px; */
.drawer-title-icon
  width 56px
  text-align center
  height inherit
  background rgba(10, 33, 64, 0.831372549019608)
  color #fff
  height 53px
  line-height 53px
.drawer-title-header
  display flex
  justify-content space-between
  width calc(100% - 56px)
.drawer-title-text
  height inherit
  padding 0px 16px
  font-size 14px
.drawer-tabs-content
  margin 0 16px
.drawer-title-text-tootip
  white-space nowrap
  display flex
.drawer-operate
  display flex
  align-items center
  width calc(100% - 500px)
  justify-content flex-end
  padding-right 20px
.drawer-tabs> >>>.el-tabs__header
  margin 0
  padding 0
  width 55px
  border-bottom none
.drawer-tabs>>>.el-tabs__content
  border-top 1px solid #f0f2f5
  border-left 1px solid #f0f2f5
  height calc(100vh - 60px)
  overflow-y auto
.drawer-tabs> >>>.el-tabs__header .el-tabs__active-bar
  display none
.drawer-tabs> >>>.el-tabs__header .el-tabs__item
  padding 0 !important
  height 53px
.drawer-tabs> >>>.el-tabs__header .el-tabs__item.is-active
  background-color #ff8b00
  color #fff
.drawer-tabs> >>>.el-tabs__header .el-tabs__item :hover
  color rgba(0, 0, 0, 0.65)
.drawer-tabs> >>>.el-tabs__header .el-tabs__item span
  font-size 14px
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 56px
  height 53px
  line-height 2
  font-weight bold
.drawer-tabs>>>.tab-left
  width 100%
  display flex
  height 100%
.drawer-tabs>>>.el-tabs__content .el-tab-pane
  height 100%
  padding 0 16px
</style>
